import { Box, IconButton, Tooltip } from "@mui/material";
import HelpOutlineRoundedIcon from "@mui/icons-material/HelpOutlineRounded";
import { motion } from "framer-motion";

interface HelpButtonProps {
    label: string;
    onClick: () => void;
    color?: string;
    /** Attira l'attenzione con qualche pulsazione, solo al primo accesso. */
    pulse?: boolean;
}

export function HelpButton({ label, onClick, color = "black", pulse = false }: HelpButtonProps) {
    return (
        <Tooltip title={label} arrow>
            <Box sx={{ position: "relative", display: "inline-flex" }}>
                {pulse && (
                    <motion.span
                        style={{
                            position: "absolute",
                            inset: "0.25rem",
                            borderRadius: "50%",
                            border: `2px solid ${color}`,
                            pointerEvents: "none",
                        }}
                        animate={{ scale: [1, 1.7], opacity: [0.5, 0] }}
                        transition={{
                            duration: 1.4,
                            repeat: 2,
                            repeatDelay: 0.3,
                            ease: "easeOut",
                        }}
                    />
                )}
                <motion.div
                    style={{ display: "inline-flex", borderRadius: "50%" }}
                    animate={pulse ? { scale: [1, 1.12, 1] } : undefined}
                    transition={{ duration: 1.4, repeat: 2, repeatDelay: 0.3, ease: "easeInOut" }}
                >
                    <IconButton onClick={onClick} aria-label={label} sx={{ color }}>
                        <HelpOutlineRoundedIcon />
                    </IconButton>
                </motion.div>
            </Box>
        </Tooltip>
    );
}
